import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <div className={this.props.className}>
        <NavMenu />
        <Container>
            {this.props.children}
            <hr />
            <div className="copy">© {new Date().getFullYear()} SIA "InterGranit", All rights reserved. </div>
        </Container>
      </div>
    );
  }
}
